import React, { useState } from 'react'
import { ReactComponent as AddAudience } from '../../../../images/add_customers.svg'
import classNames from 'classnames'
import { Button } from '@demandlocal/components'
import { ReactComponent as AudienceCustomTypeIcon } from '../../../../images/audience/audience_custom_type_icon.svg'
import { ReactComponent as LogoSimple } from '../../../../images/logo_vertical_colored.svg'
import { ReactComponent as ArrowIcon } from '../../../../images/list_arrow.svg'
import { useNavigate } from 'react-router'
import toast from 'react-hot-toast'

const EmptyTagAudiences = (): JSX.Element => {
  const [optionSelected, setOptionSelected] = useState<number | null>(null)

  const navigate = useNavigate()

  const onSubmit = (): void => {
    switch (optionSelected) {
      case 2:
        navigate('../../campaigns/list/create/select')
        return
      case 3:
        window.open(
          "mailto:sales@link1data.com?subject=I'm interested in creating custom audiences in LinkOne",
          '_blank',
        )
        return
      default:
        toast.error('You must select an option before continuing', { duration: 5000 })
        return
    }
  }

  return (
    <div className="flex flex-col justify-center items-center font-Spartan gap-3 px-5">
      <AddAudience className=" h-52 w-52" />
      <span className="font-bold text-xl">You have no tag audiences yet</span>
      <span>Here are a few things you can do:</span>
      <div className="flex flex-row *:w-1/3 justify-center gap-3">
        <div
          className={classNames(
            'flex flex-col p-2 gap-2 rounded-md border-[3px] cursor-pointer',
            {
              'border-primary-persian-blue': optionSelected === 2,
              'border-web-gray/20': optionSelected !== 2,
            },
          )}
          onClick={(e) => {
            e.preventDefault()
            setOptionSelected(2)
          }}>
          <div className="flex flex-row justify-center items-center">
            <div className="flex items-center justify-center my-5 mx-auto rounded-full w-20 h-20 bg-white border-4 border-primary-persian-blue/10">
              <AudienceCustomTypeIcon className="object-contain" />
            </div>
          </div>
          <span className="font-bold text-center">
            Run a LinkOne campaign using your customers!
          </span>
          <span className="text-center"></span>
          <ul className="p-2 *:pb-2">
            <li className="flex items-start gap-2">
              <ArrowIcon className="h-6 w-6 mt-0.5 flex-shrink-0 " />
              <span>Run an Amazon Ads Campaign</span>
            </li>
            <li className="flex items-start gap-2">
              <ArrowIcon className="h-6 w-6 mt-0.5 flex-shrink-0 " />
              <span>Run a Display Campaign</span>
            </li>
            <li className="flex items-start gap-2">
              <ArrowIcon className="h-6 w-6 mt-0.5 flex-shrink-0 " />
              <span>Run a Google Ads Campaign</span>
            </li>
          </ul>
        </div>
        <div
          className={classNames(
            'flex flex-col justify-start items-center p-2 gap-2 rounded-md border-[3px] cursor-pointer',
            {
              'border-primary-persian-blue': optionSelected === 3,
              'border-web-gray/20': optionSelected !== 3,
            },
          )}
          onClick={(e) => {
            e.preventDefault()
            setOptionSelected(3)
          }}>
          <div className="flex flex-row justify-center items-center">
            <div className="flex items-center justify-center my-5 mx-auto rounded-full w-20 h-20 bg-white border-4 border-primary-persian-blue/10">
              <LogoSimple className="object-contain px-2" />
            </div>
          </div>
          <span className="font-bold text-center">Let us Help You</span>
          <span className="text-center">
            Work with our LinkOne representative to view custom audiences
          </span>
          <ul className="p-2 *:pb-2">
            <li className="flex items-start gap-2">
              <ArrowIcon className="h-6 w-6 mt-0.5 flex-shrink-0 " />
              <span>
                Have a skilled representative create audiences based on your criteria
              </span>
            </li>
            <li className="flex items-start gap-2">
              <ArrowIcon className="h-6 w-6 mt-0.5 flex-shrink-0 " />
              <span>
                Reach a wide range of advertising platforms based on expert
                recommendations
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-row justify-end">
        <Button
          variant="rainbow"
          onClick={(e) => {
            e.preventDefault()
            onSubmit()
          }}>
          Continue
        </Button>
      </div>
    </div>
  )
}

export default EmptyTagAudiences
